/**
 * Tear Sheet Modal Handler
 * Handles opening/closing the tear sheet modal and print functionality
 */

(function() {
  'use strict';

  let modal, overlay, closeBtn, viewBtn, printBtn;

  function init() {
    modal = document.getElementById('tear-sheet-modal');
    overlay = document.getElementById('tear-sheet-modal-overlay');
    closeBtn = document.getElementById('tear-sheet-modal-close');
    viewBtn = document.getElementById('btn-view-tear-sheet');
    printBtn = document.getElementById('btn-print-tear-sheet');

    if (!modal || (!viewBtn && !printBtn)) {
      return; // Not on product page or no buttons found
    }

    // View tear sheet button (if it exists)
    if (viewBtn) {
      viewBtn.addEventListener('click', openModal);
    }

    // Print tear sheet button (opens modal then prints) - if it exists
    if (printBtn) {
      printBtn.addEventListener('click', function() {
        openModal();
        // Wait for modal to fully render, then print
        setTimeout(function() {
          // Add print class to body for print-specific styles
          document.body.classList.add('printing-tear-sheet');
          window.print();
          // Remove class after print dialog closes
          setTimeout(function() {
            document.body.classList.remove('printing-tear-sheet');
          }, 1000);
        }, 500);
      });
    }

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Overlay click to close
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('aria-hidden')) {
        closeModal();
      }
    });

    // Prevent body scroll when modal is open
    function preventBodyScroll() {
      if (!modal.hasAttribute('aria-hidden')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }

    // Watch for modal visibility changes
    const observer = new MutationObserver(preventBodyScroll);
    if (modal) {
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'style']
      });
    }
  }

  function openModal() {
    if (!modal) return;

    modal.style.display = 'flex';
    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';

    // Focus management
    if (closeBtn) {
      closeBtn.focus();
    }
  }

  function closeModal() {
    if (!modal) return;

    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Return focus to the button that opened the modal
    if (document.activeElement === closeBtn || document.activeElement === overlay) {
      if (viewBtn) {
        viewBtn.focus();
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

